var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c("modal", {
        staticClass: "catalog-panel loader-panel",
        attrs: {
          show: _vm.showModal,
          showContent: _vm.showContent,
          pageTitle: _vm.title,
          acl: _vm.acl,
          url: _vm.url,
          closeBtn: _vm.closeBtn,
          position: "right",
          size: "medium",
          id: "catalog-root",
          classContent: "overflow-hidden",
        },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(" " + _vm._s(_vm.title)),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "panel-control d-flex flex-column flex-fill overflow-hidden",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "panel-control-content d-flex flex-column flex-fill overflow-hidden",
                        },
                        [
                          _vm.isEditMode
                            ? [
                                _c("service-editor", {
                                  attrs: {
                                    saving: _vm.saving,
                                    service: _vm.newService,
                                    services: _vm.services,
                                    serviceTypes: _vm.lists.serviceTypes,
                                    selectedService: _vm.selectedService,
                                    disabled: _vm.readonlyFormItem,
                                  },
                                  on: {
                                    onChangeCatalogMode:
                                      _vm.onChangeCatalogMode,
                                    onAddService: _vm.onAddService,
                                    onDeleteService: _vm.onDeleteService,
                                  },
                                }),
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row d-flex flex-column flex-fill flex-nowrap overflow-hidden",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-12" },
                                      [
                                        _c("service-selector", {
                                          attrs: {
                                            services: _vm.services,
                                            selectedService:
                                              _vm.selectedService,
                                            isValidServiceSelected:
                                              _vm.isValidServiceSelected,
                                            enableAddService:
                                              _vm.enableAddService,
                                            disabled:
                                              _vm.readonlyFormItem ||
                                              _vm.loading,
                                          },
                                          on: {
                                            onChangeSelectedService:
                                              _vm.onChangeSelectedService,
                                            onChangeCatalogMode:
                                              _vm.onChangeCatalogMode,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12" },
                                      [
                                        _c(
                                          "MaterialInput",
                                          {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "min:3",
                                                expression: "'min:3'",
                                              },
                                            ],
                                            staticClass:
                                              "city-form-group city-bg",
                                            attrs: {
                                              disabled:
                                                !_vm.selectedService ||
                                                _vm.loading,
                                              readonly: _vm.readonlyFormItem,
                                              type: "text",
                                              id: "input-search",
                                              name: "search",
                                              inputClasses: [
                                                {
                                                  "is-invalid":
                                                    _vm.fnHasError("search"),
                                                },
                                              ],
                                              error: _vm.fnFirstError("search"),
                                            },
                                            on: {
                                              input: _vm.onSearchTextChange,
                                              keyEnter: _vm.onKeyEnter,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "grpAppend",
                                                  fn: function () {
                                                    return [
                                                      _vm.includeResetButton
                                                        ? _c(
                                                            "button",
                                                            {
                                                              key: "catalog_reset_button",
                                                              staticClass:
                                                                "btn btn-light m-0 min-w-auto",
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.selectedService ||
                                                                  !_vm.form
                                                                    .search ||
                                                                  _vm.loading,
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.reset.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-times",
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.includeSearchButton
                                                        ? _c(
                                                            "button",
                                                            {
                                                              key: "catalog_search_button",
                                                              staticClass:
                                                                "btn btn-main",
                                                              attrs: {
                                                                "data-toggle":
                                                                  "tooltip-city",
                                                                disabled:
                                                                  !_vm.selectedService ||
                                                                  _vm.loading,
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.onKeyEnter.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-search",
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              2747803219
                                            ),
                                            model: {
                                              value: _vm.form.search,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "search",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "form.search",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Pesquise...\n                                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 d-flex flex-column flex-fill overflow-hidden",
                                      },
                                      [
                                        _vm.loading
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "catalog-results loading",
                                                },
                                                [
                                                  _c("div", {}, [
                                                    _c("div", {
                                                      staticClass:
                                                        "full-size-loader",
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          : [
                                              _vm.loadingError
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "alert alert-danger",
                                                        attrs: {
                                                          role: "alert",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              _vm.errorMsg
                                                            ) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.result &&
                                                  _vm.result
                                                    .numberOfRecordsMatched ===
                                                    0
                                                ? [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "alert alert-primary",
                                                          attrs: {
                                                            role: "alert",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            No record matched\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                : _vm.result
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "catalog-results flex-scroll",
                                                      },
                                                      [
                                                        _c("record-grid", {
                                                          key: "records",
                                                          attrs: {
                                                            catalogURL:
                                                              (_vm.isValidServiceSelected &&
                                                                _vm.service
                                                                  .url) ||
                                                              "",
                                                            service:
                                                              _vm.service,
                                                            crs: _vm.crs,
                                                            map: _vm.getMap(),
                                                            catalogType:
                                                              _vm.service &&
                                                              _vm.service.type,
                                                            showTemplate:
                                                              _vm.service &&
                                                              _vm.service
                                                                .showTemplate,
                                                            defaultFormat:
                                                              _vm.service &&
                                                              _vm.service
                                                                .format,
                                                            formatOptions:
                                                              _vm.service &&
                                                              _vm.service
                                                                .url ===
                                                                _vm.service.url
                                                                ? _vm.formatOptions
                                                                : _vm.DEFAULT_FORMAT_WMS,
                                                            infoFormatOptions:
                                                              _vm.service &&
                                                              _vm.service
                                                                .url ===
                                                                _vm.service.url
                                                                ? _vm.infoFormatOptions
                                                                : _vm.getUniqueInfoFormats(),
                                                            records:
                                                              _vm.records,
                                                            layerBaseConfig:
                                                              _vm.layerBaseConfig,
                                                          },
                                                          on: {
                                                            onLayerAdd:
                                                              _vm.onLayerAdd,
                                                            onError:
                                                              _vm.onError,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          4171877179
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }